const BIKE_OD_RANGE_IN_YEARS = 4;

export const BikeOdRange = registrationYear => {
  try {
    const isInBikeOdRange =
      new Date().getFullYear() - registrationYear <= BIKE_OD_RANGE_IN_YEARS;
    return isInBikeOdRange;
  } catch (err) {
    return false;
  }
};
